// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__d3m_n","green":"styles_green__deD7r","red":"styles_red__Mz5Jj","orange":"styles_orange__SHznb"};